import { Flow } from 'signup-constants/Flow';
import { SignupUrlGenerator } from 'signup-ui-url-generator/SignupUrlGenerator';
import { FEATURED_CALLOUT_COLOR_TYPES } from 'ecosystem-marketplace-core/constants/FeaturedCallouts';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import { isQa } from '../../utils/env';
const CMS_FREE_COLLECTION = {
  buttonText: 'View collection',
  calloutId: 'cms-free-collection',
  collectionId: 'cms-free-themes',
  description: 'Select from a variety of free website themes crafted by third-parties for our most popular use cases.',
  gradientColor: FEATURED_CALLOUT_COLOR_TYPES.CALYPSO_TO_OZ,
  headline: 'Themes for CMS Hub Free',
  id: 'cms-free-collection',
  illustration: 'marketplace-theme'
};
const CMS_FREE_SIGNUP = {
  buttonText: 'Sign up',
  calloutId: 'cms-free-signup',
  description: "Use HubSpot's free CMS tools to manage and grow your website with ease.",
  externalUrl: new SignupUrlGenerator(Flow.CmsFree, {
    env: isQa() ? 'qa' : 'prod',
    query: {
      intent: 'marketplaceTheme'
    }
  }).getUrl(),
  gradientColor: FEATURED_CALLOUT_COLOR_TYPES.THUNDERDOME_TO_CALYPSO,
  headline: 'Grow your website with free CMS tools',
  id: 'cms-free-signup',
  illustration: 'add-on-website'
};
const initialState = {
  list: [CMS_FREE_COLLECTION, CMS_FREE_SIGNUP],
  requestState: RequestStates.UNINITIALIZED
};
export default initialState;